webpackJsonp(["pages.projects.pipelines.failures"],{

/***/ "./lib/utils/bootstrap_linked_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Linked Tabs
 *
 * Handles persisting and restores the current tab selection and content.
 * Reusable component for static content.
 *
 * ### Example Markup
 *
 *  <ul class="nav-links tab-links">
 *    <li class="active">
 *      <a data-action="tab1" data-target="#tab1" data-toggle="tab" href="/path/tab1">
 *        Tab 1
 *      </a>
 *    </li>
 *    <li class="groups-tab">
 *      <a data-action="tab2" data-target="#tab2" data-toggle="tab" href="/path/tab2">
 *        Tab 2
 *      </a>
 *    </li>
 *
 *
 *  <div class="tab-content">
 *    <div class="tab-pane" id="tab1">
 *      Tab 1 Content
 *    </div>
 *    <div class="tab-pane" id="tab2">
 *      Tab 2 Content
 *    </div>
 * </div>
 *
 *
 * ### How to use
 *
 *  new LinkedTabs({
 *    action: "#{controller.action_name}",
 *    defaultAction: 'tab1',
 *    parentEl: '.tab-links'
 *  });
 */

var LinkedTabs = function () {
  /**
   * Binds the events and activates de default tab.
   *
   * @param  {Object} options
   */
  function LinkedTabs() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LinkedTabs);

    this.options = options;

    this.defaultAction = this.options.defaultAction;
    this.action = this.options.action || this.defaultAction;

    if (this.action === 'show') {
      this.action = this.defaultAction;
    }

    this.currentLocation = window.location;

    var tabSelector = this.options.parentEl + ' a[data-toggle="tab"]';

    // since this is a custom event we need jQuery :(
    $(document).off('shown.bs.tab', tabSelector).on('shown.bs.tab', tabSelector, function (e) {
      return _this.tabShown(e);
    });

    this.activateTab(this.action);
  }

  /**
   * Handles the `shown.bs.tab` event to set the currect url action.
   *
   * @param  {type} evt
   * @return {Function}
   */


  _createClass(LinkedTabs, [{
    key: 'tabShown',
    value: function tabShown(evt) {
      var source = evt.target.getAttribute('href');

      return this.setCurrentAction(source);
    }

    /**
     * Updates the URL with the path that matched the given action.
     *
     * @param  {String} source
     * @return {String}
     */

  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(source) {
      var copySource = source;

      copySource.replace(/\/+$/, '');

      var newState = '' + copySource + this.currentLocation.search + this.currentLocation.hash;

      history.replaceState({
        url: newState
      }, document.title, newState);
      return newState;
    }

    /**
     * Given the current action activates the correct tab.
     * http://getbootstrap.com/javascript/#tab-show
     * Note: Will trigger `shown.bs.tab`
     */

  }, {
    key: 'activateTab',
    value: function activateTab() {
      return $(this.options.parentEl + ' a[data-action=\'' + this.action + '\']').tab('show');
    }
  }]);

  return LinkedTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (LinkedTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/projects/pipelines/failures/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_pipelines__ = __webpack_require__("./pages/projects/pipelines/init_pipelines.js");


document.addEventListener('DOMContentLoaded', __WEBPACK_IMPORTED_MODULE_0__init_pipelines__["a" /* default */]);

/***/ }),

/***/ "./pages/projects/pipelines/init_pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./lib/utils/bootstrap_linked_tabs.js
var bootstrap_linked_tabs = __webpack_require__("./lib/utils/bootstrap_linked_tabs.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: ./pipelines.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var pipelines_Pipelines = function Pipelines() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Pipelines);

  if (options.initTabs && options.tabsOptions) {
    // eslint-disable-next-line no-new
    new bootstrap_linked_tabs["a" /* default */](options.tabsOptions);
  }

  if (options.pipelineStatusUrl) {
    Object(common_utils["E" /* setCiStatusFavicon */])(options.pipelineStatusUrl);
  }
};

/* harmony default export */ var pipelines = (pipelines_Pipelines);
// CONCATENATED MODULE: ./pages/projects/pipelines/init_pipelines.js


/* harmony default export */ var init_pipelines = __webpack_exports__["a"] = (function () {
  var controllerAction = document.querySelector('.js-pipeline-container').dataset.controllerAction;

  var pipelineStatusUrl = document.querySelector('.js-pipeline-tab-link a').getAttribute('href') + '/status.json';

  new pipelines({ // eslint-disable-line no-new
    initTabs: true,
    pipelineStatusUrl: pipelineStatusUrl,
    tabsOptions: {
      action: controllerAction,
      defaultAction: 'pipelines',
      parentEl: '.pipelines-tabs'
    }
  });
});

/***/ })

},["./pages/projects/pipelines/failures/index.js"]);


// WEBPACK FOOTER //
// pages.projects.pipelines.failures.4c1dfd62b839397f9ac6.bundle.js